import { render, staticRenderFns } from "./DataCalculatorDialog.vue?vue&type=template&id=36b04e64&"
import script from "./DataCalculatorDialog.vue?vue&type=script&lang=js&"
export * from "./DataCalculatorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports